// views.app.dashboard

export const DASHBOARD = {
  title: 'Hi {{firstName}}',
  description: 'Welcome to your personalized security dashboard!'
};
